<template>
<div class="chapter">
<div class="inner_page">
<p class="bkt1" id="d7e71"><b>      atomic RANCH</b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Grin_ISBN9781423600022_epub_c1_r1.vue?5a5be864